import i18next from 'i18next';

// TODO: Need to revise the alt texts with the client.
i18next.addResources('en', 'home', {
  HERO_TITLE: 'Make every rep count',
  PLAY_BUTTON: 'Play video',
  INTRODUCING_TITLE: 'The Pivot \nstation',
  INTRODUCING_TITLE_CAPTION_1: 'A smarter \nhome gym',
  INTRODUCING_CONTENT_CAPTION_1:
    'The most modern, intelligent gym is now live in your living room. Equipped with computer vision technology that empowers coaches to actively guide, correct, and motivate you. Meaningful, live metrics that keep you engaged and inspired by your performance. And premium equipment crafted to empower you through each exercise.',
  INTRODUCING_TITLE_CAPTION_2: 'Deep insights \nin one touch',
  INTRODUCING_CONTENT_CAPTION_2:
    'The Pivot’s interactive touch screen showcases an important set of live metrics including your active heart rate, leaderboard standing, rep count, and an interval timer.',
  INTRODUCING_TITLE_CAPTION_3: 'No mess, \nno stress',
  INTRODUCING_CONTENT_CAPTION_3:
    'Everything your workout comes with—barbell, assorted weights, workout mat, heart monitor (and more) has a home inside the Pivot.',
  MANIFESTO_TITLE_1: 'Work \nsmarter',
  MANIFESTO_TITLE_2: 'and \nharder',
  MANIFESTO_CONTENT_1:
    'Cancel the ‘30 minutes on the elliptical and chill on your phone’ routine. Recycle the mediocre weight set that you inherited from your college apartment. And stop settling for guesswork and ‘what’s trending’ when it comes to your fitness goals.',
  MANIFESTO_IMAGE_1_ALT_TEXT: 'Person dancing on yellow background',
  MANIFESTO_CONTENT_2:
    'It’s time to get inspired. Look forward to your workout and ignite a shimmering pride at what your body can do, while seamlessly setting goals for what’s next. It’s time to get what you need. On your terms, on your turf, every time.',
  MANIFESTO_IMAGE_2_ALT_TEXT: 'Person standing in front of the Pivot machine',
  RIGHT_MOVES_TITLE: 'Powering the right moves',
  RIGHT_MOVES_CONTENT:
    'Working out is less about the reps and more about your form. That’s why during your workout, Pivot coaches collaborate with Pivot Vision to study 23 of your body’s joints to ensure you’re doing each curl, lift, or burpee correctly and work with you after to perfect your form.',
  RIGHT_MOVES_BUTTON: 'Learn More',
  FEEDBACK_TITLE: 'Feedback to fuel you',
  FEEDBACK_TEXT:
    'Glance up during class and see your rep count. Get in deep and review the depth of your squats after class. Watch your spot on the leaderboard climb with each rep commitment. With Pivot, you’ll always know where you’re at—and be equipped to grow to where you want to be.',
  WEIGHTS_TITLE: 'Premium \neverything',
  WEIGHTS_SUBTITLE: 'Better than \nbody weight',
  WEIGHTS_CONTENT:
    'And easy on your floor. Pivot weights are rubber coated for a stable hold, finished in hues you won’t mind in your living room, and bumper padded to appease any downstairs neighbors.',
  WEIGHT_1: 'Weight 1.25lb',
  WEIGHT_2: 'Weight 2.5lb',
  WEIGHT_5: 'Weight 5lb',
  WEIGHT_10: 'Weight 10lb',
  BARBELLS_TITLE: 'Real goals need real equipment',
  BARBELLS_CONTENT:
    'Like our weights, all our gear is made to sustain and serve your fitness journey today, tomorrow, and way beyond. Our dumbbells and barbell are stainless steel with oxidation-resistant smooth sleeves for easy loading and knurled shafts for max grip.',
  BARBELLS_COLLAR: 'Collar',
  BARBELLS_COLLAR_2: 'Collar rotate',
  BARBELLS_LARGE_BAR: 'Large bar',
  BARBELLS_SMALL_BAR: 'Small bar',
  CLASSES_COACHES_TITLE_1: 'Sweat \nthree ways',
  CLASSES_COACHES_TITLE_2: 'Your \ncoaches',
  CLASSES_COACHES_BTN_CLASSES: 'Discover classes',
  CLASSES_COACHES_BTN_COACHES: 'Meet more coaches',
  SUBSCRIPTION_TITLE: 'Go all in,\n on you',
  SUBSCRIPTION_MONTHS: '/mo for {{number}} months',
  SUBSCRIPTION_DESCRIPTION:
    'And grab Pivot’s world-class coaches and always evolving class library for an additional {{price}} a month.',
  PIVOT_IMAGE: 'Pivot fitness',
  MODAL_CONTENT: 'Pivot video',
  FEEDBACK_CALORIES: 'Calories',
  FEEDBACK_LIFTING: 'LIFTING DURATION \n35 min',
  FEEDBACK_POUNDS: 'Volume',
  FEEDBACK_RESTING: 'RESTING DURATION \n10 min',
  FEEDBACK_LEADERBOARD: 'Leaderboard',
  FEEDBACK_MUSCLE: 'MUSCLE GROUPS \nAbs, Legs'
});
